module.exports = __webpack_public_path__ + "static/media/m3pblue.4c928ee3.png";